module.exports = __webpack_public_path__ + "img/fi-rr-shuffle.6cca2c72.svg";